import React, { useState } from 'react';
import axios from "axios";
//import axios from "axios";
import { Dropdown, Button, Modal } from 'react-bootstrap';
import * as XLSX from "xlsx";


function removeWhiteSpace(obj) {
    if (typeof obj !== "object") return obj;
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            obj[prop.replace(" ", "")] =  removeWhiteSpace(obj[prop]); 
            if (prop.indexOf(" ") > -1) { 
                delete obj[prop];  
            } 
        }
    }
    return obj;
}

const Carica_alunni_XLS = (props) => {

    const [value, setValue] = useState();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [lista_alunni, SET_lista_alunni] = useState([]);
    const handleSubmit1 = (e) => {
        alert('scrivi qualcosa')
    }

    async function Invia_mail_richiesta_dati(parametro_passato) {
        console.log('invia_mail_richiesta_dati');
        handleClose()
    }


    const readExcel = (file) => {


        console.log ('dentro read excel')
        {/* idroslab  lettura di un file excel*/}

        const promise = new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.readAsArrayBuffer(file);
    
          fileReader.onload = (e) => {
            const bufferArray = e.target.result;
    
            const wb = XLSX.read(bufferArray, { type: "buffer" });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws);
    
            resolve(data);
          };
    
        fileReader.onerror = (error) => {
            console.log (error)
            reject(error);
          };
        });
    
        promise.then((d) => {
          console.log ('stato cambiato')
          console.log (d)
          let output
          var ob=removeWhiteSpace(d); 
          console.log(ob)
          SET_lista_alunni(d);
        });
      };


    const Salva_alunni_nella_classe = () => {
        console.log('Salva alunni')

        lista_alunni.map((item, index) => {

           
            const nuovo_alunno = {
                classe_id: props.classe._id,
                nome: item.NOME,
                cognome: item.COGNOME,
                data_nascita: item.DATAN,
                luogo_nascita: item.COM_NASC,
                codice_fiscale: item.COD_FISC,
                indirizzo_citta: item.COM_RES,
                indirizzo_via: item.IND_RES,
                email: item.E_MAIL,
                email_genitore1: item.EMAIL_MA,
                email_genitore2: item.EMAIL_PA
            }
    
            axios.post('/alunni/salva_nuovo', nuovo_alunno)
                .then((res) => {
                    console.log(res.data)
                }).catch((error) => {
                    console.log(error)
                });
            

        })
        setShow(false)
          
    };


    return (
        <>
        <Dropdown.Item onClick={() => setShow(true)}> Carica alunni </Dropdown.Item>
        
        <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Caricalmento alunni</Modal.Title>
        </Modal.Header>
        <Modal.Body>Carica un file di tipo XLS

        <input
            type="file"
            onChange={(e) => {
            const file = e.target.files[0];
            readExcel(file);
            }}
        />


         {lista_alunni.map((d, index) => (
            <tr key={d.InputA}>
              <th>{d.InputA}</th>
              <td>{d.InputB}</td>
              <td>{index}</td>
              <td>{d.COGNOME}</td>
             
            </tr>
          ))}

        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Annulla
            </Button>

        
            <Button variant="primary" onClick={() => Salva_alunni_nella_classe()}>
                Salva nella classe
            </Button>
        </Modal.Footer>
        </Modal>

        </>
    )
}
export default Carica_alunni_XLS;